import { Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { MessageService } from 'primeng/api';
import { DialogService, DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { CoreDialogService } from 'src/app/core/dialogs/core-dialog.service';
import { ViewsService } from 'src/app/core/view/views.service';
import { MailingDetailComponent } from 'src/app/mailing/mailing-detail/mailing-detail.component';
import { ViewComponent } from '../../../core/view/view.component';
import { OrganizationsService } from '../../organizations.service';
import { OrganizationsDetailGeneralComponent } from '../organizations-detail-general/organizations-detail-general.component';
import { ContactsService } from './contacts.service';
import { MailMarketingNotificationToStatsComponent } from 'src/app/mail-marketing/mail-marketing-notification-to-stats/mail-marketing-notification-to-stats.component';
import { Location } from '@angular/common';

@Component({
  selector: 'app-organizations-contacts-detail',
  templateUrl: './organizations-contacts-detail.component.html',
  styleUrls: ['./organizations-contacts-detail.component.scss']
})
export class OrganizationsContactsDetailComponent implements OnInit {
  public contact: any = {};
  public organization: any = {};
  @ViewChild("view") public view: ViewComponent;

  constructor(
    private route: ActivatedRoute,
    private organizationsService: OrganizationsService,
    private messageService: MessageService,
    private contactService: ContactsService,
    //private config: DynamicDialogConfig,
    //private dynamicDialogRef: DynamicDialogRef,
    private coreDialogService: CoreDialogService,
    private dialogService: DialogService,
    private router: Router,
    private viewsService: ViewsService,
    private _location: Location
  ) { }

  ngOnInit(): void {

    this.route.params.subscribe(params => {
      console.log("params -> ", params);
      this.loadData(params["id"]);
    });
  }
  loadData(id: number) {

    if (id != 0) {
      this.contactService.get(id).subscribe(
        data => {
          this.contact = data;
          this.refreshAll();
        },
        error => {
          this.messageService.add({ closable: false, severity: 'error', summary: 'Error', detail: error.error.title });
        }
      );
    } else {
      this.route.params.subscribe(params => {
        this.contact.organization_id = parseInt(params["organizationId"]);
      });
      //this.contact.organization_id = this.config.data.id;
    }
  }
  loadDataOrganization(id: number) {
    this.organizationsService.get(id).subscribe(
      data => {
        this.organization = data;
      },
      error => {
        this.messageService.add({ closable: false, severity: 'error', summary: 'Error', detail: error.error.title });
      }
    )
  }
  cancel() {
    this._location.back();
    //this.dynamicDialogRef.close();
  }
  save(event: any) {
    if (!event.valid) {
      this.messageService.add({ closable: false, severity: "error", detail: "Datos incompletos. Por favor, revisa el formulario." });
      return;
    }
    if (this.contact.email != null) this.contact.email = this.contact.email.trim();
    if (this.contact.email != null && this.contact.email.length > 0 && !this.validateEmail(this.contact.email)) {
      this.messageService.add({ closable: false, severity: "error", detail: "Debes introducir un email válido." });
      return;
    }

    if (typeof this.contact.id === "undefined") {
      this.contactService.add(this.contact).subscribe(
        data => {
          this.messageService.add({ closable: false, severity: 'success', summary: "Contacto añadido correctamente." });
          //this.dynamicDialogRef.close(data);
          this._location.back();
        },
        error => {
          this.messageService.add({ closable: false, severity: "error", detail: error.error.title });
        }
      )
    } else {
      this.contactService.save(this.contact.id, this.contact).subscribe(
        data => {
          this.messageService.add({ closable: false, severity: "success", detail: "Contacto guardado correctamente" });
          //this.dynamicDialogRef.close(data);
          this._location.back();
        },
        error => {
          this.messageService.add({ closable: false, severity: "error", detail: error.error.title });
        }
      )
    }
  }
  delete() {
    this.coreDialogService.confirm({
      message: "¿Quieres borrar el contacto " + this.contact.name + "?",
      header: "Confirmación de borrado",
      icon: "pi pi-info-circle",
      accept: () => {
        this.contactService.delete(this.contact.id).subscribe(
          data => {
            this.messageService.add({ closable: false, severity: 'success', detail: "Borrado correctamente" });
            //this.dynamicDialogRef.close();
            this._location.back();
          },
          error => {
            this.messageService.add({ closable: false, severity: 'error', detail: error.error.title });
          }
        )
      },
      reject: () => {

      }
    })
  }
  newMail(emailAcc) {
    const ref = this.dialogService.open(MailingDetailComponent, {
      data: {
        to: emailAcc,
        entity_id: 2,
        entity_pk_id: this.contact.id,
        organization_id: this.contact.organization_id,
        contact_id: this.contact.id,
        //template_type_id: 1,
        template_type_code: "MAIL",
        searchRelated: true
      },
      header: "Nuevo mensaje de correo",
      width: '70%',
    });
    ref.onClose.subscribe((data: any) => {
      if (data) {
        //this.dynamicDialogRef.close(data);
        location.reload();
      }
      if (typeof (this.view) !== "undefined") this.viewsService.changeView(this.view.code);
    });
  }

  isDuplied(contact, event) {
    if (!event.valid) {
      this.messageService.add({ closable: false, severity: "error", detail: "Datos incompletos. Por favor, revisa el formulario." });
      return;
    }
    this.contactService.isDuplied(contact).subscribe(
      data => {
        if (data == true) {
          this.coreDialogService.notify({
            message: "Ya existe un contacto con estos datos proporcionados.",
            header: 'Error',
            icon: 'far, exclamation-circle',
            color: 'var(--orange-500)',
            accept: () => { }
          });
        } else {
          this.save(event);
        }
      }
    );
  }
  refreshAll() {
    this.view.view?.configuration?.components?.array?.forEach(component => {
      this.view.fireEvent(component.code, "reload");
    });
  }
  onEvent(event: any) {
    if (event.event == "refreshAll" && event.action.name == "refreshAll") this.loadData(this.contact.id);
    if (event.component == "contacts.detail") {
      if (event.event == "action" && event.action.name == "openNotificationStats") this.openNotificationStats();
      if (event.event == "action" && event.action.name == "delete") this.delete();
      if (event.event == "action" && event.action.name == "cancel") this.cancel();
      if (event.event == "action" && event.action.name == "save") this.isDuplied(this.contact, event);
      if (event.event == "fieldAction" && event.action.name == "new-mail") this.newMail(event.value);
      if (event.event == "action" && event.action.name == "openNotificationsStats") this.openNotificationStats();
      if (event.event == "action" && event.action.name == "openEmails") this.openEmails();
    }
    if (event.component == "view" && event.event == "entity-loaded") {
      //this.config.header = typeof (this.contact.id) !== "undefined" ? "Detalles del " + this.view.getEntityBaseName() : "Nuevo " + this.view.getEntityBaseName();
    }
  }

  openNotificationStats() {
    const ref = this.dialogService.open(MailMarketingNotificationToStatsComponent, {
      data: {
        //organization_id: this.contact.organization_id,
        contact_id: this.contact.id,
      },
      header: "Informe de clics",
      width: '70%'
    });
    ref.onClose.subscribe((data: any) => {
      //nothing
    })
  }


  validateEmail(email) {
    const re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(email);
  }

  openEmails() {
    if (this.contact.id != null) this.router.navigate(["/emails", (this.organization.id ? this.organization.id : 0), this.contact.id]); this.cancel();
  }
}
